import React, { useState, useEffect, useRef } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import StyleHome from "../Styles/Common.module.css";
import Style from "../Styles/DashboardStyle.module.css";
//import Button from '../Styles/Button.module.css';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import constants from "../../services/constants";
import BreadcrumbComponent from "../Common/CommonSections/Breadcrum";
import thumImage from "../../assest/images/list-img01.png";
import {
  getCountryListFormData,
  getCityListByStateId,
  getCategoryListFormData,
  getStateListByCountryId,
} from "../../services/routes.services";
import { IoIosRefreshCircle } from "react-icons/io";
import { FaEye, FaEyeSlash  } from "react-icons/fa";

const RegistrationPage = () => {
  const navigate = useNavigate();
  const selectRef = useRef(null);
  const selectStateRef = useRef(null);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(thumImage);
  const [profession, setProfession] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [captchaImage, setCaptchaImage] = useState(""); // To store CAPTCHA image
  const [captchaText, setCaptchaText] = useState("");
  const initialFormData = {
    name: "",
    last: "",
    gender: "",
    email: "",
    phone: "",
    link: "",
    dob: "",
    batch: "",
    school: "",
    rollno: "",
    houseinmayo: "",
    country: "",
    state: "",
    city: "",
    address: "",
    pin: "",
    categoryId: "",
    orgname: "",
    designation: "",
    password: "",
    confirmPassword: "",
    captchaText: captchaText,
  };
  const [formData, setFormData] = useState(initialFormData);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const passwordHandler=()=>{
      if(showPassword === false){
          setShowPassword(true)
      }else{
          setShowPassword(false)
      }
  }
  const passwordConfirmHandler=()=>{
      if(showConfirmPassword === false){
          setShowConfirmPassword(true)
      }else{
          setShowConfirmPassword(false)
      }
  }
  useEffect(() => {
    getCountryListFormData()
      .then((res) => {
        setCountries(res.data.countries);
      })
      .catch((error) => {
        console.log(error);
      });

    getCategoryListFormData()
      .then((res) => {
        setProfession(res.data.categories);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const handleCountryChange = (e) => {
    //const selectedCountry = e.target.value;
    const selectedOption =
      selectRef.current.options[selectRef.current.selectedIndex];
    const selectedCountry = selectedOption.id;

    setFormData({
      ...formData,
      country: selectedOption.value,
      state: "",
      city: "",
    });
    setErrors({ ...errors, [e.target.name]: "" });
    setSubmitError("");
    setStates([]);
    setCities([]);
    // Fetch states based on selected country
    getStateListByCountryId(selectedCountry)
      .then((res) => {
        setStates(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleStateChange = (e) => {
    //const selectedState = e.target.value;
    const selectedOption =
      selectStateRef.current.options[selectStateRef.current.selectedIndex];
    const selectedState = selectedOption.id;
    setFormData({ ...formData, state: selectedOption.value, city: "" });
    setErrors({ ...errors, [e.target.name]: "" });
    setSubmitError("");
    setCities([]);
    // Fetch cities based on selected state
    getCityListByStateId(selectedState)
      .then((res) => {
        setCities(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const validate = () => {
    console.log("form data",formData)
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.last) newErrors.last = "Last name is required";
    if (!formData.gender) newErrors.gender = "Gender is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.phone) newErrors.phone = "Phone no is required";
    if (!formData.categoryId) newErrors.categoryId = "Profession is required";
    if (!formData.dob) newErrors.dob = "Date of birth is required";
    if (!formData.batch) newErrors.batch = "Batch is required";
    if (!formData.school) newErrors.school = "School name is required";
    if (!formData.country) newErrors.country = "Country is required";
    if (!formData.state) newErrors.state = "State is required";
    //if (!formData.city) newErrors.city = 'City is required';
    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.orgname) newErrors.orgname = "Organisation name is required";
    if (!formData.designation)
      newErrors.designation = "Designation is required";
    if (!formData.pin) newErrors.pin = "Pincode is required";
    if (!formData.houseinmayo)
      newErrors.houseinmayo = "House in mayo is required";
    if (!formData.rollno) newErrors.rollno = "Roll no is required";
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Email address is invalid";
    if (!formData.password) newErrors.password = "Password is required";
    if (formData.password && formData.password.length < 6)
      newErrors.password = "Password must be at least 6 characters";
    if (!formData.confirmPassword)
      newErrors.confirmPassword = "Confirm Password is required";
    if (
      formData.confirmPassword &&
      formData.password !== formData.confirmPassword
    )
      newErrors.confirmPassword = "Passwords do not match!";
    if (!formData.captchaText)
      newErrors.captchaText = "Security code is required";
    return newErrors;
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
    setSubmitError("");
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      //setFormData({ ...formData, image: file });
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    const formDataToSend = new FormData();
    for (const key in formData) {
      formDataToSend.append(key, formData[key]);
    }

    if (selectedImage) {
      // check if imageFile is not the default image
      formDataToSend.append("image", selectedImage);
    }
    try {
      const response = await axios.post(
        constants.API_BASE_URL + "alumni/create/alumni",
        formDataToSend,
        {withCredentials: true}
      );
      setSuccessMessage("User added successfully!");
      setTimeout(() => setSuccessMessage(""), 5000);
      setFormData(initialFormData);
      handleExitPage();
    } catch (error) {
      console.error("There was an error saving the user!", error);
      setSubmitError(
        error.response?.data?.error || "An error occurred while saving the user"
      );
    }
  };
  const handleExitPage = () => {
    navigate("/");
  };
  const fetchCaptcha = async () => {
    try {
      const response = await axios.get(
        `${constants.API_BASE_URL}alumni/generate-captcha`,
        {
          responseType: "blob",
          withCredentials: true 
        },
        
      );
      const url = URL.createObjectURL(response.data);
      setCaptchaImage(url); // Set the CAPTCHA image
    } catch (error) {
      console.error("Error fetching CAPTCHA:", error);
    }
  };
  // Fetch CAPTCHA image from the backend when the component loads
  useEffect(() => {
    fetchCaptcha();
  }, []);
  const handleCaptchaChange = (e) => {
    // setCaptchaText(e.target.value);
    const { value } = e.target;
    setFormData(prev => ({
      ...prev,
      captchaText: value
    }));
  };
  return (
    <div>
      <BreadcrumbComponent home="Home" listOne="Registration" />
      <div className={StyleHome.pageTitle + " " + StyleHome.marginUp90 +" " + Style.regPage}>
        <Container>
          <Row>
            <Col>
              <div className={StyleHome.sectionTitle}>
                <h2>Registration</h2>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className={Style.newFormStyle}>
                <h3 className={Style.registerTitle}>CREATE AN ACCOUNT</h3>
                <form id="myform" method="post" noValidate>
                  <div className={Style.formContainer}>
                    <div className={Style.fromRow}>
                      <div className={Style.fromCol}>
                        <label>Add Profile Picture</label>
                        <div className={Style.addProfileImg}>
                          <figure className={Style.profileImg}>
                            {/* <img src={imageFile} alt="userImage" /> */}
                            {previewUrl && (
                              <img
                                src={previewUrl}
                                width="200"
                                alt="userImage"
                              />
                            )}
                          </figure>
                          <input
                            type="file"
                            name="image"
                            id="image"
                            onChange={handleFileChange}
                            className={
                              Style.inputStyle + " " + Style.inputFileStyle
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className={Style.fromRow}>
                      <div className={Style.fromCol}>
                        <label>First Name</label>
                        <input
                          type="text"
                          className={Style.inputStyle}
                          name="name"
                          id="name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                        {errors.name && (
                          <p style={{ color: "red" }}>{errors.name}</p>
                        )}
                      </div>
                      <div className={Style.fromCol}>
                        <label>Last Name</label>
                        <input
                          className={Style.inputStyle}
                          type="text"
                          name="last"
                          id="last"
                          value={formData.last}
                          onChange={handleChange}
                        />
                        {errors.last && (
                          <p style={{ color: "red" }}>{errors.last}</p>
                        )}
                      </div>
                      <div className={Style.fromCol}>
                        <label>Gender</label>
                        <select
                          className={Style.inputStyle}
                          name="gender"
                          id="gender"
                          value={formData.gender}
                          onChange={handleChange}
                        >
                          <option>Select Gender</option>
                          <option value={"Male"}>Male</option>
                          <option value={"Female"}>Female</option>
                        </select>
                        {errors.gender && (
                          <p style={{ color: "red" }}>{errors.gender}</p>
                        )}
                      </div>
                    </div>
                    <div className={Style.fromRow}>
                      <div className={Style.fromCol}>
                        <label>Batch</label>
                        <select
                          className={Style.inputStyle}
                          name="batch"
                          id="batch"
                          value={formData.batch}
                          onChange={handleChange}
                        >
                          <option>Select Batch Year</option>
                         <option value="">Select Batch Year</option>
      {Array.from({ length: 2025 - 1950 + 1 }, (_, index) => {
        const year = 1950 + index;
        return (
          <option key={year} value={year}>
            {year}
          </option>
        );
      })}
                        </select>
                        {errors.batch && (
                          <p style={{ color: "red" }}>{errors.batch}</p>
                        )}
                      </div>
                      <div className={Style.fromCol}>
                        <label>Mobile No</label>
                        <input
                          type="number"
                          className={Style.inputStyle}
                          name="phone"
                          id="phone"
                          value={formData.phone}
                          onChange={handleChange}
                        />
                        {errors.phone && (
                          <p style={{ color: "red" }}>{errors.phone}</p>
                        )}
                      </div>
                      <div className={Style.fromCol}>
                        <label>Date of Birth</label>
                        <input
                          type="date"
                          className={Style.inputStyle}
                          name="dob"
                          id="dob"
                          onChange={handleChange}
                        />
                        {errors.dob && (
                          <p style={{ color: "red" }}>{errors.dob}</p>
                        )}
                      </div>
                    </div>
                    <div className={Style.fromRow}>
                      <div className={Style.fromCol}>
                        <label>School</label>
                        <select
                          className={Style.inputStyle}
                          name="school"
                          id="school"
                          onChange={handleChange}
                        >
                          <option>Select School</option>
                          <option value="Mayo Boys">Mayo Boys</option>
                          <option value="Mayo Girls">Mayo Girls </option>
                        </select>
                        {errors.school && (
                          <p style={{ color: "red" }}>{errors.school}</p>
                        )}
                      </div>
                      <div className={Style.fromCol}>
                        <label>School Roll No.</label>
                        <input
                          type="number"
                          className={Style.inputStyle}
                          name="rollno"
                          id="rollno"
                          onChange={handleChange}
                        />
                        {errors.rollno && (
                          <p style={{ color: "red" }}>{errors.rollno}</p>
                        )}
                      </div>
                      <div className={Style.fromCol}>
                        <label>Last House In Mayo</label>
                        <input
                          type="text"
                          className={Style.inputStyle}
                          name="houseinmayo"
                          id="houseinmayo"
                          onChange={handleChange}
                        />
                        {errors.houseinmayo && (
                          <p style={{ color: "red" }}>{errors.houseinmayo}</p>
                        )}
                      </div>
                    </div>
                    <div className={Style.fromRow}>
                      <div className={Style.fromCol}>
                        <label>Country</label>
                        <select
                          ref={selectRef}
                          className={Style.inputStyle}
                          name="country"
                          id="country"
                          onChange={handleCountryChange}
                        >
                          <option>Select Country</option>
                          {countries &&
                            countries.map((country) => (
                              <option
                                id={country.id}
                                key={country.id}
                                value={country._id}
                              >
                                {country.name}
                              </option>
                            ))}
                        </select>
                        {errors.country && (
                          <p style={{ color: "red" }}>{errors.country}</p>
                        )}
                      </div>
                      <div className={Style.fromCol}>
                        <label>State</label>
                        <select
                          ref={selectStateRef}
                          className={Style.inputStyle}
                          name="state"
                          id="state"
                          onChange={handleStateChange}
                        >
                          <option>Select State</option>
                          {states &&
                            states.map((state) => (
                              <option
                                key={state.id}
                                id={state.id}
                                value={state._id}
                              >
                                {state.name}
                              </option>
                            ))}
                        </select>
                        {errors.state && (
                          <p style={{ color: "red" }}>{errors.state}</p>
                        )}
                      </div>
                      <div className={Style.fromCol}>
                        <label>City</label>
                        <select
                          className={Style.inputStyle}
                          name="city"
                          id="city"
                          value={formData.city}
                          onChange={handleChange}
                        >
                          <option>Select City</option>
                          {cities.map((city) => (
                            <option key={city.id} value={city._id}>
                              {city.name}
                            </option>
                          ))}
                        </select>
                        {errors.city && (
                          <p style={{ color: "red" }}>{errors.city}</p>
                        )}
                      </div>
                    </div>
                    <div className={Style.fromRow}>
                      <div className={Style.fromCol}>
                        <div>
                          <label>Pincode</label>
                          <input
                            type="number"
                            className={Style.inputStyle}
                            name="pin"
                            id="pin"
                            onChange={handleChange}
                          />
                          {errors.pin && (
                            <p style={{ color: "red" }}>{errors.pin}</p>
                          )}
                        </div>
                        <div className={Style.multiCol}>
                          <label>Email Id</label>
                          <input
                            type="email"
                            className={Style.inputStyle}
                            name="email"
                            id="email"
                            onChange={handleChange}
                          />
                          {errors.email && (
                            <p style={{ color: "red" }}>{errors.email}</p>
                          )}
                        </div>
                      </div>
                      <div className={Style.fromCol2}>
                        <label>Current Address</label>
                        <textarea
                          type="text"
                          className={Style.inputStyle}
                          name="address"
                          id="address"
                          onChange={handleChange}
                        ></textarea>
                        {errors.address && (
                          <p style={{ color: "red" }}>{errors.address}</p>
                        )}
                      </div>
                    </div>
                    <div className={Style.fromRow}>
                      <div className={Style.fromCol}>
                        <label>Profession</label>
                        <select
                          className={Style.inputStyle}
                          name="categoryId"
                          id="categoryId"
                          onChange={handleChange}
                        >
                          <option>Select Profession</option>

                          {profession.map((prof) => (
                            <option key={prof._id} value={prof._id}>
                              {prof.name}
                            </option>
                          ))}
                        </select>
                        {errors.categoryId && (
                          <p style={{ color: "red" }}>{errors.categoryId}</p>
                        )}
                      </div>
                      <div className={Style.fromCol}>
                        <label>Organization Name</label>
                        <input
                          type="text"
                          className={Style.inputStyle}
                          name="orgname"
                          id="orgname"
                          onChange={handleChange}
                        />
                        {errors.orgname && (
                          <p style={{ color: "red" }}>{errors.orgname}</p>
                        )}
                      </div>
                      <div className={Style.fromCol}>
                        <label>Designation</label>
                        <input
                          type="text"
                          className={Style.inputStyle}
                          name="designation"
                          id="designation"
                          onChange={handleChange}
                        />
                        {errors.designation && (
                          <p style={{ color: "red" }}>{errors.designation}</p>
                        )}
                      </div>
                    </div>
                    <div className={Style.fromRow}>
                      <div className={Style.fromCol}>
                        <label>Password</label>
                        <input
                          type={showPassword ? 'text' : 'password'}
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                          required
                          className={Style.inputStyle}
                        />
                        <button className={Style.showPass} type="button" onClick={passwordHandler}>
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                        {errors.password && (
                          <p style={{ color: "red" }}>{errors.password}</p>
                        )}
                      </div>
                      <div className={Style.fromCol}>
                        <label>Confirm Password</label>
                        <input
                          type={showConfirmPassword ? 'text' : 'password'}
                          className={Style.inputStyle}
                          name="confirmPassword"
                          value={formData.confirmPassword}
                          onChange={handleChange}
                          required
                        />
                        <button className={Style.showPass} type="button" onClick={passwordConfirmHandler}>
                            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                        {errors.confirmPassword && (
                          <p style={{ color: "red" }}>
                            {errors.confirmPassword}
                          </p>
                        )}
                      </div>
                      <div className={Style.fromCol}>
                        <label>Security Code</label>
                        <div className={Style.flexCap}>
                          <input type="text" name="captchaText" className={Style.inputStyle}  value={formData.captchaText} onChange={handleCaptchaChange} placeholder="Enter security code" required />
                          <div className={Style.captchaStyle}>
                            <img src={captchaImage} alt="CAPTCHA" />
                            <button type="button" onClick={fetchCaptcha} className={Style.refreshBtn}><IoIosRefreshCircle /></button>
                          </div>
                        </div>
                         {submitError && (
                        <p style={{ color: "red" }}>{submitError}</p>
                      )}
                        {errors.captchaText && ( <p style={{ color: "red" }}>{errors.captchaText}</p>)}
                      </div>
                    </div>
                    <div className={Style.fromRow}>
                     
                      {successMessage && (
                        <p style={{ color: "green" }}>{successMessage}</p>
                      )}
                      <div className={Style.fromCol2 + " " + Style.fromBtn}>
                        <button
                          type="button"
                          className={Style.subBtn}
                          onClick={handleSubmit}
                        >
                          Submit
                        </button>
                        <button
                          type="button"
                          onClick={handleExitPage}
                          className={Style.clearBtn}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default RegistrationPage;
